export default "__VITE_ASSET__COnGfXkR__"